export const DELIVERY_LABEL = 'Delivery (Coming Soon)';
